import { StyledDivHeader } from "Pages/DRS/DRSHeader";
import React from "react";
import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
// import TestEvaluationFilters from "Pages/TestEvaluation/Components/TestEvaluationFilters";
import {
  EVALUATED_TEST_STATUS_COLORS,
  // FILTERS_TAB_KEY,
} from "Pages/TestEvaluation/constants";
import CourseSubjectListing from "Pages/MyBatches/MyBatch/SharedComponents/CourseSubjectListing";
interface TestEvaluationHeaderIF {
  testInfo: any;
  activeTab: string;
  batchDetail?: any;
  batchDetailsData?: any;
  onBackClick?: () => void;
  batchDetailById?: any;
  selectedCourseSyllabus?: any;
  selectedCourseSyllabusHandler?: any;
}
const TestEvaluationHeader = ({
  testInfo,
  batchDetailsData = {},
  onBackClick,
  batchDetailById,
  selectedCourseSyllabus,
  selectedCourseSyllabusHandler,
  activeTab,
}: // activeTab,
TestEvaluationHeaderIF) => {
  const { academicGroup: stream = "", batchName = "" } = batchDetailsData || {};
  const { screen }: any = useWindowSize();
  return (
    <StyledDivHeader
      className="d-flex align-items-center justify-content-between"
      style={{
        background: "white",
      }}
    >
      <div className="d-flex align-items-start">
        <div className="d-flex flex-col align-items-start">
          <div className="d-flex flex-row align-items-center mr-2">
            <LeftArrow
              className={"cursorHoverCSS mr-1"}
              onClick={onBackClick}
            />
            <Typography
              variant={["xxl", "xl"].includes(screen) ? "h4" : "h6"}
              color="black"
            >
              {testInfo?.testName}
            </Typography>
            <span
              style={{
                backgroundColor:
                  EVALUATED_TEST_STATUS_COLORS[testInfo?.evaluationStatus],
                color: "white",
                padding: "2px 8px",
                borderRadius: "4px",
                marginLeft: "10px",
                fontSize: "12px",
              }}
            >
              {testInfo?.evaluationStatus}
            </span>
          </div>
          <div
            className="d-flex flex-row align-items-start"
            style={{ marginLeft: "28px" }}
          >
            {batchName && stream && (
              <Typography
                variant={["xxl", "xl"].includes(screen) ? "subheading3" : "h6"}
                color="gray"
              >
                {`${batchName} | ${stream}`}
              </Typography>
            )}
          </div>
        </div>
      </div>
      {activeTab == "2" && batchDetailById && (
        <div>
          <CourseSubjectListing
            item={batchDetailById}
            selectedCourseSyllabus={selectedCourseSyllabus}
            selectedCourseSyllabusHandler={selectedCourseSyllabusHandler}
          ></CourseSubjectListing>
        </div>
      )}
    </StyledDivHeader>
  );
};

export default TestEvaluationHeader;
